var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M41.84,15H24v13l-3-1L7.16,13.26H7.14C10.68,7.69,16.91,4,24,4C31.8,4,38.55,8.48,41.84,15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M7.158,13.264l8.843,14.862L21,27L7.158,13.264z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#558b2f",
    d: "M23.157,44l8.934-16.059L28,25L23.157,44z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M41.865,15H24l-1.579,4.58L41.865,15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33,24c0,4.969-4.031,9-9,9s-9-4.031-9-9s4.031-9,9-9S33,19.031,33,24z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M31,24c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S31,20.133,31,24z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserChrome);
export default __webpack_public_path__ + "static/media/browser_chrome.db11a7d8563bc331279968d4f13b2b2d.svg";
export { ForwardRef as ReactComponent };